import { NPage } from '@app/components/Page/types/Page.main';

export const MENU_SIDEBAR_INITIAL_STATE: {
  menuSidebarState: NPage.MenuSidebarState;
} = {
  menuSidebarState: NPage.MenuSidebarState.FULL,
};
